<template>
  <div>
    <script id="editor" type="text/plain"></script>
  </div>
</template>
<script>
  export default {
    name: 'UE',
    data () {
      return {
        editor: null
      }
    },
    props: {
      defaultMsg: {
        type: String
      },
      config: {
        type: Object
      }
    },
    mounted() {
      const _this = this;
      this.editor = UE.getEditor('editor', this.config); // 初始化UE
      this.editor.addListener("ready", function () {
        _this.editor.setContent(_this.defaultMsg); // 确保UE加载完成后，放入内容。
      });
    },
    methods: {
      getUEContent() { // 获取内容方法
        return this.editor.getContent()
      },
      setUEContent(content) { // 获取内容方法
        return this.editor.setContent(content)
      },
    },
    destroyed() {
      console.log(123);
      this.editor.destroy();
    }
  }
</script>
<!--
<style>
.edui-default .edui-editor-toolbarbox{
    position: fixed!important;
    z-index:1000;
    top: 0;
    left: 0;
}

</style>
-->